


































import EmptyCell from "@/components/EmptyCell.vue";
import { EventBus } from "@/eventbus";
import Vue from "vue";
export default Vue.extend({
  components: { EmptyCell },
  props: ["source"],
  setup(props) {
    const investigate = () => {
      EventBus.emit("investigate", props.source);
    };
    return { investigate };
  },
});
